import { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Sidebar } from "primereact/sidebar";
import { EmailLogsList } from "./emailLogs/EmailLogsList";
import { SmsLogsList } from "./smsLogs/SmsLogsList";
import { PushLogsList } from "./pushLogs/PushLogsList";
import { MassEmailDialog } from "./emailLogs/MassEmailDialog";
import { MassSmsDialog } from "./smsLogs/MassSmsDialog";
import { IconButton } from "../../../common/components/button/iconButton/IconButton";
import { IconType } from "../../../common/icons/Icon";
import { CommunicationLogsFilterSidebar } from "./components/CommunicationLogsFilterSidebar";
import { CommunicationLogsTabHeader } from "./components/CommunicationLogsTabHeader";
import { useCommunicationLogsFilters } from "./hooks/useCommunicationLogsFilters";
import styles from "./CommunicationLogs.module.scss";

export const CommunicationLogs = () => {
  const [isMassEmailDialogOpen, setIsMassEmailDialogOpen] = useState(false);
  const [isMassSmsDialogOpen, setIsMassSmsDialogOpen] = useState(false);

  const {
    canSeePushLogs,
    activeIndex,
    onTabChange,
    activeFilterCount,
    openActiveSidebar,
    isEmailSidebarOpen,
    setIsEmailSidebarOpen,
    isSmsSidebarOpen,
    setIsSmsSidebarOpen,
    isPushSidebarOpen,
    setIsPushSidebarOpen,
    emailFilterUserIds,
    setEmailFilterUserIds,
    emailFilterEmailTypes,
    setEmailFilterEmailTypes,
    emailTypeOptions,
    smsFilterUserIds,
    setSmsFilterUserIds,
    pushFilterUserIds,
    setPushFilterUserIds,
    emailUserOptions,
    smsUserOptions,
    pushUserOptions,
    clearEmailFilters,
    clearSmsFilters,
    clearPushFilters,
  } = useCommunicationLogsFilters();

  const emailTabHeader = (
    <CommunicationLogsTabHeader
      label="Имейли"
      menuItems={[
        {
          label: "Нов имейл",
          icon: IconType.Envelope,
          onClick: () => setIsMassEmailDialogOpen(true),
        },
      ]}
    />
  );

  const smsTabHeader = (
    <CommunicationLogsTabHeader
      label="SMS"
      menuItems={[
        {
          label: "Нов SMS",
          icon: IconType.Phone,
          onClick: () => setIsMassSmsDialogOpen(true),
        },
      ]}
    />
  );

  return (
    <div className={styles.root}>
      <div className={styles.tabs_wrapper}>
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => onTabChange(e.index)}
          className={styles.root_tabs}
        >
          <TabPanel header={emailTabHeader}>
            <EmailLogsList
              filterUserIds={emailFilterUserIds}
              filterEmailTypes={emailFilterEmailTypes}
            />
          </TabPanel>
          <TabPanel header={smsTabHeader}>
            <SmsLogsList filterUserIds={smsFilterUserIds} />
          </TabPanel>
          {canSeePushLogs && (
            <TabPanel header={<CommunicationLogsTabHeader label="Известия" />}>
              <PushLogsList filterUserIds={pushFilterUserIds} />
            </TabPanel>
          )}
        </TabView>

        <div className={styles.tabs_filter_button}>
          <div className={styles.filterIconWrapper}>
            <IconButton
              iconType={IconType.Filters}
              iconHeight="18px"
              iconWidth="18px"
              onClick={openActiveSidebar}
              className={activeFilterCount > 0 ? styles.filterButtonActive : ""}
            />
            {activeFilterCount > 0 && (
              <span className={styles.filterBadge}>{activeFilterCount}</span>
            )}
          </div>
        </div>
      </div>

      <Sidebar
        header={<h3 className={styles.sidebar_title}>Филтри</h3>}
        visible={isEmailSidebarOpen}
        className={styles.sidebar_menu}
        position="right"
        onHide={() => setIsEmailSidebarOpen(false)}
      >
        <CommunicationLogsFilterSidebar
          userOptions={emailUserOptions}
          filterUserIds={emailFilterUserIds}
          onFilterUserIdsChange={setEmailFilterUserIds}
          emailTypeOptions={emailTypeOptions}
          filterEmailTypes={emailFilterEmailTypes}
          onFilterEmailTypesChange={setEmailFilterEmailTypes}
          onClearAll={clearEmailFilters}
          onClose={() => setIsEmailSidebarOpen(false)}
        />
      </Sidebar>

      <Sidebar
        header={<h3 className={styles.sidebar_title}>Филтри</h3>}
        visible={isSmsSidebarOpen}
        className={styles.sidebar_menu}
        position="right"
        onHide={() => setIsSmsSidebarOpen(false)}
      >
        <CommunicationLogsFilterSidebar
          userOptions={smsUserOptions}
          filterUserIds={smsFilterUserIds}
          onFilterUserIdsChange={setSmsFilterUserIds}
          onClearAll={clearSmsFilters}
          onClose={() => setIsSmsSidebarOpen(false)}
        />
      </Sidebar>

      <Sidebar
        header={<h3 className={styles.sidebar_title}>Филтри</h3>}
        visible={isPushSidebarOpen}
        className={styles.sidebar_menu}
        position="right"
        onHide={() => setIsPushSidebarOpen(false)}
      >
        <CommunicationLogsFilterSidebar
          userOptions={pushUserOptions}
          filterUserIds={pushFilterUserIds}
          onFilterUserIdsChange={setPushFilterUserIds}
          onClearAll={clearPushFilters}
          onClose={() => setIsPushSidebarOpen(false)}
        />
      </Sidebar>

      <MassEmailDialog
        visible={isMassEmailDialogOpen}
        onHide={() => setIsMassEmailDialogOpen(false)}
      />
      <MassSmsDialog
        visible={isMassSmsDialogOpen}
        onHide={() => setIsMassSmsDialogOpen(false)}
      />
    </div>
  );
};
